function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.7 21.75H9.3c-4.94 0-7.05-2.11-7.05-7.05V9.3c0-4.94 2.11-7.05 7.05-7.05h5.4c4.94 0 7.05 2.11 7.05 7.05v5.4c0 4.94-2.11 7.05-7.05 7.05zm-5.4-18c-4.1 0-5.55 1.45-5.55 5.55v5.4c0 4.1 1.45 5.55 5.55 5.55h5.4c4.1 0 5.55-1.45 5.55-5.55V9.3c0-4.1-1.45-5.55-5.55-5.55H9.3z"
})));